// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1anOS","info":"Note_info__3ju0U","note":"Note_note__2y8s_","actions":"Note_actions__13vGl"};